/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ state: NonNullable<unknown> }} Explorer_Info_State_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "State updated to \"{state}\"" |
*
* @param {Explorer_Info_State_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_state_updated_toast = /** @type {((inputs: Explorer_Info_State_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_State_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Etat mis a jour vers "${i?.state}"`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Status aktualisiert auf "${i?.state}"`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Stato aggiornato a "${i?.state}"`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Состояние обновлено до "${i?.state}"`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Estado actualizado a "${i?.state}"`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`状态已更新为“${i?.state}”`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`状態が「${i?.state}」に更新されました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`राज्य को "${i?.state}" में अपडेट किया गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Estado atualizado para "${i?.state}"`)
	return /** @type {LocalizedString} */ (`State updated to "${i?.state}"`)
});